import { render, staticRenderFns } from "./client-header.vue?vue&type=template&id=bee1e27a"
import script from "./client-header.vue?vue&type=script&lang=js"
export * from "./client-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports